import React from 'react'
import './sign-up-success-component.scss'

class SignupSuccessComponent extends React.Component {
  state = {}

  render() {
    const { name } = this.props
    return (
      <>
        <div className='row maths-day-container'>
          <div class='maths-day-description signup-success-description'>
            <p className='slogan-text'>Hello, {name}</p>
            <p>
            Your school registration for<span className='bold-text-event-name'> {this.props.eventName} </span> is now complete. Your application is under review and will get approved shortly. We typically approve all valid applications in less than 24 hours. You will receive an email and a WhatsApp message on your registered mobile number once the process is complete.
            </p>
            <p className="pt-4">
              Once the application is approved, you will also receive a call from our team member who will guide you through the process and assist in you making your school's participation successful.
            </p>
          </div>
        </div>
      </>
    )
  }
}

export default SignupSuccessComponent
